import { useCallback } from 'react';
import { useOpenDeeplink } from '../../../../hooks';
import { appendParams, finalizeUrl, getDefaultDeeplink } from '../../utils';

const GOODS_LIST_DEEPLINK_PREFIX = 'ably://goods_list';

const parseGoodsListDeeplink = (deeplink: string) => {
  if (!deeplink.startsWith(GOODS_LIST_DEEPLINK_PREFIX)) return null;
  const queryPart = deeplink.split('?')[1];
  if (!queryPart) return null;

  const params = new URLSearchParams(queryPart);
  const goodsSnoRaw = params.get('goods_sno');
  const type = params.get('type');
  if (!goodsSnoRaw || !type) return null;

  const goodsSno = Number(goodsSnoRaw);
  if (Number.isNaN(goodsSno)) return null;

  // Navigator.convertParams가 snake_case로 읽으므로 동일 형태로 보존
  return {
    type,
    goods_sno: goodsSno,
    landing_from: params.get('landing_from') ?? undefined,
    position: params.get('position') ?? undefined,
  };
};

export const useMoveToGoodsList = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(
    (deeplink: string) => {
      const extras = parseGoodsListDeeplink(deeplink);
      if (extras === null) return false;

      const url = getDefaultDeeplink();
      appendParams(url, 'screen', 'GoodsList');
      appendParams(url, 'extras', JSON.stringify(extras));

      openDeeplink(finalizeUrl(url));
      return true;
    },
    [openDeeplink],
  );
};
